<fieldset>
  <legend>
    TypeCPVClass
  </legend>
  <button (click)="addclassSupplementaire()" class="btn btn-outline-primary">Ajouter un classSupplementaire</button>
  <div *ngFor="let obj of typeCPVClass.classSupplementaire; let i = index">
    <fieldset>
      <legend>
        classSupplementaire {{ i + 1}}
      </legend>
      <button (click)="removeclassSupplementaire(i)" class="btn btn-outline-primary">Supprimer un classSupplementaire</button>
      <app-form-input  [label]="'classSupplementaire'"
                      [name]="getUid()+'_index_'+(i+1)+'_SepAtt_classSupplementaire'"
                      [parentForm]="parentForm" [rule]="''" [value]="obj">
      </app-form-input>
    </fieldset>
  </div>

  <app-form-input  [label]="'classPrincipale'"
                  [name]="getUid()+'_SepAtt_classPrincipale'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeCPVClass.classPrincipale">
  </app-form-input>
</fieldset>
